import { Link, Navigate, NavLink, useParams } from 'react-router-dom';
import './MethodologyPage.css';

const DOCS = [
  {
    id: 'ranking',
    title: 'Ранжирование',
    file: 'ranking-lifecycle-flow.html',
  },
  {
    id: 'order',
    title: 'Заказ',
    file: 'order-lifecycle-flow.html',
  },
  {
    id: 'penalties',
    title: 'Штрафы и блокировки',
    file: 'seller-penalties-blocks.html',
  },
  {
    id: 'notifications',
    title: 'Уведомления',
    file: 'notifications-guide.html',
  },
  {
    id: 'slots',
    title: 'Слоты',
    file: 'slots-flow.html',
  },
] as const;

export default function MethodologyPage() {
  const { docId } = useParams<{ docId?: string }>();
  const current = DOCS.find((d) => d.id === docId) ?? DOCS[0];

  if (docId && !DOCS.some((d) => d.id === docId)) {
    return <Navigate to="/help/ranking" replace />;
  }

  const src = `${import.meta.env.BASE_URL}docs/${current.file}`;

  return (
    <div className="admin-help-page">
      <aside className="admin-help-page__nav" aria-label="Методики">
        <header className="admin-help-page__head">
          <Link to="/" className="admin-help-page__back">
            ← В кабинет
          </Link>
          <h1 className="admin-help-page__title">Помощь</h1>
        </header>
        <nav className="admin-help-page__list">
          {DOCS.map((doc) => (
            <NavLink
              key={doc.id}
              to={`/help/${doc.id}`}
              className={({ isActive }) =>
                `admin-help-page__item${isActive ? ' active' : ''}`
              }
            >
              {doc.title}
            </NavLink>
          ))}
        </nav>
      </aside>
      <iframe className="admin-help-page__frame" title={current.title} src={src} />
    </div>
  );
}
